import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../Components/TableHelper";
import { useFormik } from "formik";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../Components/Breadcrumb";
import { traceabilitySchema } from "../../Validation/Validation";
import CodeEditor from "../../Components/CodeEditor";

const AddTraceability = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;
  const initalvalues = {
    traceabilityName: editData?.traceabilityName,
    description: editData?.description || "",
    sortOrder: editData?.sortOrder || 1,
    isActive: editData?.isActive ?? false,
  };
  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: initalvalues,
    validationSchema: traceabilitySchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = editingId
          ? await axiosInstance.put(
              `/traceability/updateTraceability/${editingId}`,
              values,
            )
          : await axiosInstance.post(
              "/traceability/createTraceability",
              values,
            );

        if (response.status === 200) {
          toast.success(response.data.message);
          navigator("/traceability");
        }
      } catch (error) {
        toast.error(error.response?.data?.message);
        return error;
      } finally {
        setLoading(false);
      }
    },
  });

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Traceability", path: "/traceability" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Source
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="traceability-sortOrder"
                        className="col-form-label "
                      >
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className="form-control  border-dark "
                        id="traceability-sortOrder"
                        name="sortOrder"
                        placeholder="Enter  Sort Order"
                        min={1}
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">
                          {errors.sortOrder}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="traceabilityName"
                        className="col-form-label "
                      >
                        Name
                      </label>
                      <input
                        type="text"
                        className={`form-control border-dark`}
                        id="traceabilityName"
                        name="traceabilityName"
                        placeholder="Enter Source name"
                        value={values.traceabilityName || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.traceabilityName && errors.traceabilityName && (
                        <small className="text-danger">
                          {errors.traceabilityName}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="Source-description"
                        className="col-form-label "
                      >
                        Description
                      </label>
                      <CodeEditor
                        value={values.description}
                        onChange={(val) => setFieldValue("description", val)}
                      />
                      {touched.description && errors.description && (
                        <small className="text-danger">
                          {errors.description}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6 mt-4">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                  <Link to="/traceability">
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTraceability;
